import React from 'react';
import { Check, ChevronDown } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { Button, Menu, rem, Text } from '@good/ui/core';

type Level = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingOption = {
  label: string;
  value: 'paragraph' | Level;
  fontSize: string;
};

const headingOptions: HeadingOption[] = [
  { label: 'Paragraph', value: 'paragraph', fontSize: '14px' },
  { label: 'Heading 1', value: 1, fontSize: '32px' },
  { label: 'Heading 2', value: 2, fontSize: '24px' },
  { label: 'Heading 3', value: 3, fontSize: '20px' },
  { label: 'Heading 4', value: 4, fontSize: '18px' },
  { label: 'Heading 5', value: 5, fontSize: '16px' },
  { label: 'Heading 6', value: 6, fontSize: '14px' },
];

export const HeadingLevelDropdown = () => {
  const { editor, disabled } = useRichTextEditor();

  const activeOption = headingOptions.find((option) => {
    if (option.value === 'paragraph') {
      return editor.isActive('paragraph');
    }
    return editor.isActive('heading', { level: option.value });
  });

  const isDisabled = disabled;

  const onChange = (value: 'paragraph' | Level) => {
    if (value === 'paragraph') {
      editor.chain().focus().setParagraph().run();
    } else {
      editor.chain().focus().setHeading({ level: value }).run();
    }
  };

  return (
    <Menu shadow='md' width={200} position='bottom-start'>
      <Menu.Target>
        <Button
          size='xs'
          variant='outline'
          color='neutral'
          aria-label='heading-level'
          disabled={isDisabled}
          leftSection={
            <Text size='xs' fw={400} pl={rem(8)} style={{ minWidth: rem(80) }} className='text-left'>
              {activeOption?.label || 'Paragraph'}
            </Text>
          }
          rightSection={
            <Text size='xs' c='var(--brand-body-dark-2)' w={rem(30)} pr={rem(8)}>
              <ChevronDown />
            </Text>
          }
          w={150}
        />
      </Menu.Target>
      <Menu.Dropdown>
        {headingOptions.map((option) => (
          <Menu.Item
            key={option.value}
            onClick={() => onChange(option.value)}
            leftSection={
              activeOption?.value === option.value ? (
                <Text size='xs' c='var(--brand-body-dark-2)'>
                  <Check />
                </Text>
              ) : undefined
            }
          >
            <Text size='xs' style={{ fontSize: option.fontSize }}>
              {option.label}
            </Text>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
